"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("./utils");
const FullGrid = (0, app_1.styled)(ui_1.Grid) `
  width: 100%;
  @media ${app_1.mobile} {
    grid-template-columns: 1fr;
  }
`;
function Columns({ columns, spacing = 'medium', }) {
    return ((0, jsx_runtime_1.jsx)(FullGrid, Object.assign({ className: "column", templateColumns: (0, utils_1.buildRatiosGrid)(columns, 'column'), gap: spacing }, { children: columns.sort(utils_1.sortByOrder).map((column) => ((0, jsx_runtime_1.jsx)(utils_1.FullGridItem, Object.assign({ className: "column-item", noCenter: true }, { children: (0, jsx_runtime_1.jsx)(utils_1.SectionElement, { element: column }, column.id) }), column.id))) })));
}
exports.Columns = Columns;
